import axios from 'axios';
const urlBase =
  'https://gateway-admin-plus.sistemainteegra.com.br/api-admin-mobile';
  // 'https://gateway-admin-plus.inteegrav2.com.br/api-admin-mobile';
  
async function getStockActivities(eventId) {
  const config = {
    method: 'get',
    url: `${urlBase}/temp/estoqueatividades/event/${eventId}`,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

export { getStockActivities };
